//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './SignerClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type DeleteSignerQueryParameters = {
  id?: number | undefined ;
}

export type SearchSignerQueryParameters = {
  firstName?: string | undefined ;
  lastName?: string | undefined ;
  email?: string | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type VerifyPatchAbilitySignerQueryParameters = {
  id: number ;
}

export type PatchSignerQueryParameters = {
  id: number ;
}

export type GetSignerQueryParameters = {
  id: number ;
}

export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/signers";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'SignerClient',
      'create',
    ]);
}

export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.SignerDto, unknown, Types.SignerCreateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.SignerDto, unknown, Types.SignerCreateDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.SignerCreateDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function deleteUrl(id?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/signers?";
if (id === null)
    throw new Error("The parameter 'id' cannot be null.");
else if (id !== undefined)
    url_ += "id=" + encodeURIComponent("" + id) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteMutationKey(id?: number | undefined): MutationKey {
  return trimArrayEnd([
      'SignerClient',
      'delete',
      id as any,
    ]);
}

export function useDeleteMutation<TContext>(id?: number | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.delete_(id),
    mutationKey: key,
  });
}
  
type Delete__MutationParameters = DeleteSignerQueryParameters

export function useDeleteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Delete__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeleteSignerQueryParameters}): UseMutationResult<void, unknown, Delete__MutationParameters, TContext> {
  const key = deleteMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Delete__MutationParameters) => Client.delete_(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function searchUrl(firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/signers?";
if (firstName === null)
    throw new Error("The parameter 'firstName' cannot be null.");
else if (firstName !== undefined)
    url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
if (lastName === null)
    throw new Error("The parameter 'lastName' cannot be null.");
else if (lastName !== undefined)
    url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
if (email === null)
    throw new Error("The parameter 'email' cannot be null.");
else if (email !== undefined)
    url_ += "Email=" + encodeURIComponent("" + email) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchDefaultOptions: Omit<UseQueryOptions<Types.PagedResultOfSignerDto, unknown, Types.PagedResultOfSignerDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultOfSignerDto, unknown, Types.PagedResultOfSignerDto>, 'queryFn'>> = {
};
export function getSearchDefaultOptions() {
  return searchDefaultOptions;
};
export function setSearchDefaultOptions(options: typeof searchDefaultOptions) {
  searchDefaultOptions = options;
}

export function searchQueryKey(dto: SearchSignerQueryParameters): QueryKey;
export function searchQueryKey(firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function searchQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { firstName, lastName, email, offset, limit, sortBy, sortOrder,  } = params[0] as SearchSignerQueryParameters;

    return trimArrayEnd([
        'SignerClient',
        'search',
        firstName as any,
        lastName as any,
        email as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'SignerClient',
        'search',
        ...params
      ]);
  }
}
export function __search(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.search(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as string | undefined,       context.queryKey[4] as string | undefined,       context.queryKey[5] as number | null | undefined,       context.queryKey[6] as number | null | undefined,       context.queryKey[7] as string | null | undefined,       context.queryKey[8] as Types.SortOrder | undefined,axiosConfig    );
}

export function useSearchQuery<TSelectData = Types.PagedResultOfSignerDto, TError = unknown>(dto: SearchSignerQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultOfSignerDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useSearchQuery<TSelectData = Types.PagedResultOfSignerDto, TError = unknown>(firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.PagedResultOfSignerDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchQuery<TSelectData = Types.PagedResultOfSignerDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfSignerDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let firstName: any = undefined;
  let lastName: any = undefined;
  let email: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ firstName, lastName, email, offset, limit, sortBy, sortOrder,  } = params[0] as SearchSignerQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [firstName, lastName, email, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultOfSignerDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __search(context, axiosConfig) : __search,
    queryKey: searchQueryKey(firstName, lastName, email, offset, limit, sortBy, sortOrder),
    ...searchDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultOfSignerDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setSearchData(queryClient: QueryClient, updater: (data: Types.PagedResultOfSignerDto | undefined) => Types.PagedResultOfSignerDto, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(searchQueryKey(firstName, lastName, email, offset, limit, sortBy, sortOrder),
    updater
  );
}

export function setSearchDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfSignerDto | undefined) => Types.PagedResultOfSignerDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function verifyPatchAbilityUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/signers/{id}/patch-ability";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let verifyPatchAbilityDefaultOptions: Omit<UseQueryOptions<string[], unknown, string[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<string[], unknown, string[]>, 'queryFn'>> = {
};
export function getVerifyPatchAbilityDefaultOptions() {
  return verifyPatchAbilityDefaultOptions;
};
export function setVerifyPatchAbilityDefaultOptions(options: typeof verifyPatchAbilityDefaultOptions) {
  verifyPatchAbilityDefaultOptions = options;
}

export function verifyPatchAbilityQueryKey(id: number): QueryKey;
export function verifyPatchAbilityQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as VerifyPatchAbilitySignerQueryParameters;

    return trimArrayEnd([
        'SignerClient',
        'verifyPatchAbility',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'SignerClient',
        'verifyPatchAbility',
        ...params
      ]);
  }
}
export function __verifyPatchAbility(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.verifyPatchAbility(
      context.queryKey[2] as number,axiosConfig    );
}

export function useVerifyPatchAbilityQuery<TSelectData = string[], TError = unknown>(dto: VerifyPatchAbilitySignerQueryParameters, options?: Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * If Signer is used in signing, returns the list of project names that will be invalidated.
 */
export function useVerifyPatchAbilityQuery<TSelectData = string[], TError = unknown>(id: number, options?: Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useVerifyPatchAbilityQuery<TSelectData = string[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as VerifyPatchAbilitySignerQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<string[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __verifyPatchAbility(context, axiosConfig) : __verifyPatchAbility,
    queryKey: verifyPatchAbilityQueryKey(id),
    ...verifyPatchAbilityDefaultOptions as unknown as Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * If Signer is used in signing, returns the list of project names that will be invalidated.
 */
export function setVerifyPatchAbilityData(queryClient: QueryClient, updater: (data: string[] | undefined) => string[], id: number) {
  queryClient.setQueryData(verifyPatchAbilityQueryKey(id),
    updater
  );
}

/**
 * If Signer is used in signing, returns the list of project names that will be invalidated.
 */
export function setVerifyPatchAbilityDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string[] | undefined) => string[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/signers/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'SignerClient',
      'patch',
      id as any,
    ]);
}

export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.SignerDto, unknown, Types.PatchSignerDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.SignerDto, unknown, Types.PatchSignerDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchSignerDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchSignerQueryParameters & {
  dto: Types.PatchSignerDto;
}

export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.SignerDto, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchSignerQueryParameters}): UseMutationResult<Types.SignerDto, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function getUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/signers/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.SignerDto, unknown, Types.SignerDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.SignerDto, unknown, Types.SignerDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(id: number): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetSignerQueryParameters;

    return trimArrayEnd([
        'SignerClient',
        'get',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'SignerClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.SignerDto, TError = unknown>(dto: GetSignerQueryParameters, options?: Omit<UseQueryOptions<Types.SignerDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetQuery<TSelectData = Types.SignerDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.SignerDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.SignerDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SignerDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetSignerQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.SignerDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(id),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.SignerDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetData(queryClient: QueryClient, updater: (data: Types.SignerDto | undefined) => Types.SignerDto, id: number) {
  queryClient.setQueryData(getQueryKey(id),
    updater
  );
}

export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SignerDto | undefined) => Types.SignerDto) {
  queryClient.setQueryData(queryKey, updater);
}